import { useState } from 'react'
import { getClientList } from '../../../../shared/services/ClientUserSetupService'
import { SYSTEM_MESSAGE_IDS } from '../../../../shared/constants/systemMessages.constants'
import { useTranslation } from 'react-i18next'
import { downloadFileACHExceptionRulesTemplate } from 'src/app/shared/services/ACHExceptionRuleService'

export enum EnumSelectAction {
  create,
  edit,
}

export interface IFormUpload {
  clientName: string | null
  selectAction: EnumSelectAction
  uploadFile: any
}

export const fileExtension = ['.xlsx']

const FILE_ACCEPT: {
  [key: string]: string
} = {
  excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  excel_xls: 'application/vnd.ms-excel',
}
export const LIMITED_FILE_SIZE = 10485760

export const useClientSelectData = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [clientOptions, setClientOptions] = useState<Array<{ label: string; value: string }>>([])
  const [totalRecords, setTotalRecords] = useState(0)

  const formatResData = (data: any): { label: string; value: string }[] => {
    return data?.map((item: any) => ({
      label: item.clientName,
      value: item.clientName,
    }))
  }

  const getClientOptions = async () => {
    try {
      setIsLoading(true)

      const data = await getClientList()
      setClientOptions(formatResData(data?.data))
      setTotalRecords(data?.data?.total)

      return data?.data
    } catch (e) {
      console.log('ERROR: ', e)
    } finally {
      setIsLoading(false)
    }
  }

  return { clientOptions, totalRecords, getClientOptions, isLoading }
}

export const useFormRules = () => {
  const { t } = useTranslation()

  const messageClientNameRequired = t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
    Required_Field: `${t('ACHExceptionRule:uploadModal.uploadFile.clientName')}`,
  })
  const messageAccountFileRequired = t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
    Required_Field: `${t('ACHExceptionRule:uploadModal.uploadFile.uploadFile')}`,
  })

  return {
    clientName: {
      required: {
        value: true,
        message: messageClientNameRequired,
      },
    },
    uploadFile: {
      required: {
        value: true,
        message: messageAccountFileRequired,
      },
    },
  }
}

export const validateFile = (file: any, t: any): string => {
  /*VALIDATE FILE EXTENSION*/
  const regex = /\.xlsx\b/

  if (!Object.values(FILE_ACCEPT).includes(file.type) || !regex.test(file.name)) {
    return `${t('ACHExceptionRule:uploadModal.uploadFile.PPP02')}`
  }

  /*VALIDATE FILE SIZE*/
  if (file.size > LIMITED_FILE_SIZE) {
    return `${t('ACHExceptionRule:uploadModal.uploadFile.PPP01')}`
  }

  return ''
}

export const useDownloadFileTemplate = () => {
  const [isLoading, setIsLoading] = useState(false)

  const downloadFileACHExceptionRules = async () => {
    try {
      setIsLoading(true)

      const data = await downloadFileACHExceptionRulesTemplate()
      return data?.data
    } catch (e) {
      console.log('ERROR: ', e)
    } finally {
      setIsLoading(false)
    }
  }

  return { downloadFileACHExceptionRules, isLoading }
}
